export function getPageTitle(pathname, language = 'bn') {
    const t = {
        		bn: {
			home: 'গ্রামীণ বাজার - হোম',
			bazars: 'বাজারের তালিকা',
			daily: 'নিত্যপণ্যে',
			medicine: 'ঔষধ বাজার',
			food: 'ফ্রেশ খাবার',
			grains: 'শস্য',
			national: 'জাতীয় পণ্য',
			garments: 'গার্মেন্টস',
			cosmetics: 'কসমেটিক্স',
			books: 'বই',
			nursery: 'নার্সারি',
			electronics: 'ইলেক্ট্রনিক্স',
			chemical: 'কেমিক্যাল',
			hardware: 'হার্ডওয়্যার',
			service: 'সার্ভিস বাজার',
			feed: 'পশু খাদ্য',
			cart: 'কার্ট',
			checkout: 'চেকআউট',
			search: 'সার্চ ফলাফল',
			privacy: 'প্রাইভেসি পলিসি',
			about: 'আমাদের সম্পর্কে',
			help: 'সাহায্য',
			contact: 'যোগাযোগ',
			career: 'ক্যারিয়ার',
			becomeSeller: 'বিক্রেতা হিসেবে যোগ দিন',
			store: 'স্টোর',
			product: 'পণ্যের বিস্তারিত',
			upazilaAdminDashboard: 'উপজেলা প্রশাসক ড্যাশবোর্ড',
		},
		en: {
			home: 'Grameen Bazar - Home',
			bazars: 'Bazars',
			daily: 'Daily Bazar',
			medicine: 'Medicine Bazar',
			food: 'Fresh Food',
			grains: 'Grains',
			national: 'National Bazar',
			garments: 'Garments',
			cosmetics: 'Cosmetics',
			books: 'Books',
			nursery: 'Nursery',
			electronics: 'Electronics',
			chemical: 'Chemical',
			hardware: 'Hardware',
			service: 'Service Bazar',
			feed: 'Animal Feed',
			cart: 'Cart',
			checkout: 'Checkout',
			search: 'Search Results',
			privacy: 'Privacy Policy',
			about: 'About Us',
			help: 'Help',
			contact: 'Contact',
			career: 'Career',
			becomeSeller: 'Become a Seller',
			store: 'Store',
			product: 'Product Details',
			upazilaAdminDashboard: 'Upazila Admin Dashboard',
		},
        np: {
            home: 'ग्रामीण बजार - होम',
            bazars: 'बजारहरूको सूची',
            daily: 'किराना',
            medicine: 'औषधि बजार',
            food: 'ताजा खाना',
            grains: 'अन्न',
            national: 'राष्ट्रिय बजार',
            garments: 'कपडा',
            cosmetics: 'सौन्दर्य',
            books: 'पुस्तक',
            nursery: 'नर्सरी',
            electronics: 'इलेक्ट्रोनिक्स',
            chemical: 'रासायनिक',
            hardware: 'हार्डवेयर',
            service: 'सेवा बजार',
            feed: 'पशु आहार',
            cart: 'कार्ट',
            checkout: 'चेकआउट',
            search: 'खोज परिणाम',
            privacy: 'गोपनीयता नीति',
            about: 'हाम्रो बारे',
            help: 'सहायता',
            contact: 'सम्पर्क',
            career: 'क्यारियर',
            becomeSeller: 'विक्रेता बन्नुहोस्',
            store: 'स्टोर',
            product: 'वस्तुको विवरण',
        },
        de: {
            home: 'Grameen Bazar - Startseite',
            bazars: 'Basare',
            daily: 'Täglicher Basar',
            medicine: 'Medizin-Basar',
            food: 'Frische Lebensmittel',
            grains: 'Getreide',
            national: 'Nationaler Basar',
            garments: 'Bekleidung',
            cosmetics: 'Kosmetik',
            books: 'Bücher',
            nursery: 'Gärtnerei',
            electronics: 'Elektronik',
            chemical: 'Chemikalien',
            hardware: 'Hardware',
            service: 'Service-Basar',
            feed: 'Tierfutter',
            cart: 'Warenkorb',
            checkout: 'Kasse',
            search: 'Suchergebnisse',
            privacy: 'Datenschutz',
            about: 'Über uns',
            help: 'Hilfe',
            contact: 'Kontakt',
            career: 'Karriere',
            becomeSeller: 'Verkäufer werden',
            store: 'Geschäft',
            product: 'Produktdetails',
        },
        pk: {
            home: 'گرامین بازار - ہوم',
            bazars: 'بازاروں کی فہرست',
            daily: 'روزمرہ بازار',
            medicine: 'ادویات بازار',
            food: 'تازہ کھانا',
            grains: 'اناج',
            national: 'قومی بازار',
            garments: 'گارمنٹس',
            cosmetics: 'کاسمیٹکس',
            books: 'کتابیں',
            nursery: 'نرسری',
            electronics: 'الیکٹرانکس',
            chemical: 'کیمیکل',
            hardware: 'ہارڈ ویئر',
            service: 'سروس بازار',
            feed: 'جانوروں کی خوراک',
            cart: 'کارٹ',
            checkout: 'چیک آؤٹ',
            search: 'تلاش کے نتائج',
            privacy: 'پرائیویسی پالیسی',
            about: 'ہمارے بارے میں',
            help: 'مدد',
            contact: 'رابطہ',
            career: 'کیریئر',
            becomeSeller: 'سیلر بنیں',
            store: 'اسٹور',
            product: 'مصنوعات کی تفصیل',
        },
        af: {
            home: 'ګرامین بازار - کور',
            bazars: 'د بازارونو لیست',
            daily: 'روزانه بازار',
            medicine: 'د دواګانو بازار',
            food: 'تازه خواړه',
            grains: 'غله جات',
            national: 'ملکی بازار',
            garments: 'جامې',
            cosmetics: 'کاسمیټیک',
            books: 'کتابونه',
            nursery: 'نرسري',
            electronics: 'برقی توکي',
            chemical: 'کیمیاوي توکي',
            hardware: 'هارډویر',
            service: 'خدمتونه',
            feed: 'د حیواناتو خواړه',
            cart: 'کارټ',
            checkout: 'چیک آؤټ',
            search: 'د لټون پایلې',
            privacy: 'د خصوصیت پالیسي',
            about: 'زموږ په اړه',
            help: 'مرسته',
            contact: 'اړیکه',
            career: 'مسلک',
            becomeSeller: 'پلورونکی شئ',
            store: 'پلورنځی',
            product: 'د محصول تفصیلات',
        },
        cn: {
            home: '乡村集市 - 首页',
            bazars: '集市列表',
            daily: '日常集市',
            medicine: '药品集市',
            food: '新鲜食品',
            grains: '谷物',
            national: '全国集市',
            garments: '服装',
            cosmetics: '化妆品',
            books: '书籍',
            nursery: '苗圃',
            electronics: '电子产品',
            chemical: '化学品',
            hardware: '五金',
            service: '服务集市',
            feed: '动物饲料',
            cart: '购物车',
            checkout: '结账',
            search: '搜索结果',
            privacy: '隐私政策',
            about: '关于我们',
            help: '帮助',
            contact: '联系',
            career: '职业',
            becomeSeller: '成为卖家',
            store: '商店',
            product: '产品详情',
        },
	};

    const L = t[language] || t.bn;

	// Dynamic route checks first
	if (/^\/upazila-admin\/dashboard/.test(pathname)) {
		return L.upazilaAdminDashboard;
	}
	if (/^\/[\w-]+\/product\//.test(pathname)) {
		return L.product;
	}
	if (/^\/medicine-bazar\/product\//.test(pathname)) {
		return L.product;
	}
	if (/^\/stores\//.test(pathname)) {
		return L.store;
	}

	// Static mappings
	const map = new Map([
		['/', L.home],
		['/bazars', L.bazars],
		['/daily-bazar', L.daily],
		['/medicine-bazar', L.medicine],
		['/food-bazar', L.food],
		['/grains', L.grains],
		['/national-bazar', L.national],
		['/garments-bazar', L.garments],
		['/cosmetics-bazar', L.cosmetics],
		['/book-bazar', L.books],
		['/nursery-bazar', L.nursery],
		['/electronics-bazar', L.electronics],
		['/chemical-bazar', L.chemical],
		['/hardware-bazar', L.hardware],
		['/service-bazar', L.service],
		['/feed-bazar', L.feed],
		['/cart', L.cart],
		['/checkout', L.checkout],
		['/search', L.search],
		['/privacy-policy', L.privacy],
		['/about', L.about],
		['/help', L.help],
		['/contact', L.contact],
		['/career', L.career],
		['/become-seller', L.becomeSeller],
		['/upazila-admin/dashboard', L.upazilaAdminDashboard],
	]);

    return map.get(pathname) || L.home;
}


